<template>
  <a-layout-footer style="text-align: center;" class="footer">
    ©2024 佰特编码Wiki All Rights Reserved | Design <span v-show="user.id">，欢迎：{{ user.name }}</span>
  </a-layout-footer>
</template>
<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue';
import store from "@/store";
import { Tool } from "@/util/tool";
import { notification } from 'ant-design-vue';

export default defineComponent({
  name: 'TheFooter',// 同 'the-footer'
  setup() {
    const user = computed(() => store.state.user);
    console.log('user', user)

    onMounted(() => {
      // WebSocket

    });


    return {
      user
    }
  }
});

</script>
<style scoped>
.footer {
  background: white;
}
</style>